import { useEffect } from 'react';
const addNewFontHandler = (font: string) => {
  if (!font) {
    return;
  }

  const fontId = font.replaceAll(' ', '+');
  if (document.head.querySelector(`link[data-font-id="${fontId}"]`)) {
    return 'Font already loaded';
  }

  const fontUrl = `https://fonts.googleapis.com/css2?family=${fontId}:wght@100;200;300;400;500;600;700;800;900&display=swap`;
  const link = document.createElement('link');
  link.setAttribute('data-font-id', fontId);
  link.href = fontUrl;
  link.rel = 'stylesheet';
  document.head.appendChild(link);

  return 'Font loaded';
};

export const useGoogleFonts = (fonts: string | string[]) => {
  useEffect(() => {
    if (Array.isArray(fonts)) {
      fonts.forEach((font) => addNewFontHandler(font));
    } else {
      addNewFontHandler(fonts);
    }
  }, [fonts]);
};

